import { createRootRoute, createRoute, createRouter } from '@tanstack/react-router';
import MainPage from './components/landing/main/MainPage';
import SearchPage from './components/pages/SearchPage';
import BulkExportPage from './components/pages/BulkExportPage';
import BulkExportStatusPage from './components/pages/BulkExportStatusPage';
import MarketerPage from './components/landing/marketers/Page';
import GhlPage from './components/landing/ghl/Page';
import PrivacyPolicy from './components/legal/PrivacyPolicy';
import TermsOfService from './components/legal/TermsOfService';
import StatusPage from './components/pages/StatusPage';
import ApiDocs from './components/pages/ApiDocs';
import X402ApiDocs from './components/pages/X402ApiDocs';
import SuccessPage from './components/pages/SuccessPage';
import AuthPage from './components/pages/AuthPage';
import DashboardPage from './components/pages/DashboardPage';
import ReferralPage from './components/pages/ReferralPage';
import ChatPage from './components/pages/ChatPage';
import AdminPage from './components/pages/AdminPage';
import PromoBanner from './components/PromoBanner';
import { Outlet } from '@tanstack/react-router';
import { AuthProvider } from './lib/AuthContext';

// Root Layout
const rootRoute = createRootRoute({
    component: () => (
        <AuthProvider>
            <PromoBanner />
            <Outlet />
        </AuthProvider>
    ),
});

// Index Route (Home)
const indexRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/',
    component: MainPage,
});

// Search Route
const searchRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/search',
    component: SearchPage,
});

// Bulk Export Routes
const bulkExportRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/bulk-export',
    component: BulkExportPage,
});

const bulkStatusRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/bulk-status',
    component: BulkExportStatusPage,
});

// Other Pages
const marketersRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/marketers',
    component: MarketerPage,
});

const ghlRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/for/ghl-marketers',
    component: GhlPage,
});

const privacyRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/privacy',
    component: PrivacyPolicy,
});

const termsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/terms',
    component: TermsOfService,
});

const statusRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/status',
    component: StatusPage,
});

const docsRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/docs',
    component: ApiDocs,
});

const successRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/success',
    component: SuccessPage,
});

const authRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/auth',
    component: AuthPage,
});

const dashboardRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/dashboard',
    component: DashboardPage,
});

const x402ApiRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/api',
    component: X402ApiDocs,
});

const chatRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/chat',
    component: ChatPage,
});

const referralRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/ref/$code',
    component: ReferralPage,
});

const adminRoute = createRoute({
    getParentRoute: () => rootRoute,
    path: '/admin',
    component: AdminPage,
});

// Create Router
const routeTree = rootRoute.addChildren([
    indexRoute,
    searchRoute,
    bulkExportRoute,
    bulkStatusRoute,
    marketersRoute,
    ghlRoute,
    privacyRoute,
    termsRoute,
    statusRoute,
    docsRoute,
    successRoute,
    authRoute,
    dashboardRoute,
    x402ApiRoute,
    chatRoute,
    referralRoute,
    adminRoute,
]);

export const router = createRouter({ routeTree });

declare module '@tanstack/react-router' {
    interface Register {
        router: typeof router;
    }
}
